import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

export default function TopBar({ title }) {
  return (
    <Box
      sx={{
        position: 'relative',
        top: 0,
        left: 0,
        width: '100%',
        marginBottom: 2,
        backgroundColor: 'rgba(27, 112, 51, 0.65)',
        borderTopRightRadius: 2,
        borderBottomLeftRadius: 2,
      }}
    >
      <AppBar
        position="static"
        sx={{
          width: '100%',
          backgroundColor: 'rgba(27, 112, 51, 0.65)',
          borderTopRightRadius: 2,
          borderBottomLeftRadius: 2,
        }}
      >
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
